import {
  CollideEvent,
  CollideId,
  isOneHitCollider,
  isPowerCollider,
} from '../../defs/collide';
import type { BathtubBlockEntity } from '../../entities/BlockEntity';
import { despawnBlockEntity } from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { BathtubEffect } from '../effects/BathtubEffect';
import { BreakEffect } from '../effects/BreakEffect';
import { InvalidEffect } from '../effects/InvalidEffect';
import { CollideHandler, ICollision } from './ICollision';

export class BathtubCollision implements ICollision {
  private readonly scene: GameScene;
  private readonly entity: BathtubBlockEntity;
  private readonly resolvers: { [key in CollideId]?: CollideHandler } = {
    tap: this.resolveTap,
    block: this.resolveBlock,
    attack: this.resolveAttack,
  };

  constructor(scene: GameScene, entity: BathtubBlockEntity) {
    this.scene = scene;
    this.entity = entity;
  }

  public async resolve(event: CollideEvent): Promise<boolean> {
    return this.resolvers[event.id]?.call(this, event) ?? false;
  }

  private async resolveTap() {
    await new InvalidEffect(this.entity).execute();
    return false;
  }

  private async resolveAttack(event: CollideEvent) {
    if (isOneHitCollider(event.collider?.type)) {
      // Destroy the block in one hit
      this.entity.c.blockBathtub.count = 0;
    }
    await this.attack();
    return false;
  }

  private async resolveBlock(event: CollideEvent) {
    const collider = event.collider;
    if (
      collider?.type === 'block' &&
      collider.entity.c.block.props.type === 'basic'
    ) {
      await this.attack();
      return true;
    }
    return false;
  }

  private async attack() {
    const entity = this.entity;
    const position = entity.c.position.mapPosition;
    const component = entity.c.blockBathtub;

    if (component.count <= 0) {
      despawnBlockEntity(this.scene, this.entity);
      new BreakEffect(this.scene, {
        position,
        size: entity.c.block.props,
        color: 0x9dc3fd,
      }).execute();
      await new BathtubEffect(this.scene, {
        subject: this.entity,
      }).execute();
    } else {
      component.count -= 1;
      this.scene?.events.publish({ id: 'poke' });
    }
  }
}
